import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login';
import Signup from './components/Signup';
import Dashboard from './components/Dashboard';
import StationDetail from './components/StationDetail';
import UsersDashboard from './components/UsersDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import './styles/admin-theme.css';
import './App.css';
import MonthlyWqiCalendar from "./reports/MonthlyWqiCalendar";
// client/src/App.jsx (or wherever routes live)
import TwoYAxisTimePlot from "./reports/TwoYAxisTimePlot";
import ExceedanceReport from "./reports/ExceedanceReport";
import RiverParameterComparison from "./reports/RiverParameterComparison";
import RiverVsRiverComparison from "./reports/RiverVsRiverComparison";
import RiverLongitudinalProfile from "./reports/RiverLongitudinalProfile";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/station/:id" 
              element={
                <ProtectedRoute>
                  <StationDetail />
                </ProtectedRoute>
              }
            />
            <Route path="/insights" element={<Navigate to="/users" replace />} />
            <Route 
              path="/users"
              element={
                <ProtectedRoute>
                  <UsersDashboard />
                </ProtectedRoute>
              }
            />

            {/* NEW: Monthly WQI calendar */}
            <Route 
              path="/reports/monthly-wqi"
              element={
                <ProtectedRoute>
                  <MonthlyWqiCalendar />
                </ProtectedRoute>
              }
            />
            {/* optional redirect */}
            <Route path="/reports" element={<Navigate to="/reports/monthly-wqi" replace />} />

             {/* NEW: 2Y Plot Graph */}
            <Route 
              path="/reports/compare-2y"
              element={
                <ProtectedRoute>
                  <TwoYAxisTimePlot />
                </ProtectedRoute>
              }
            />
            <Route path="/reports" element={<Navigate to="/reports/compare-2y" replace />} />
			
            {/* NEW: Exceedance Report */}
              <Route 
                path="/reports/exceedance"
                element={
                <ProtectedRoute>
                  <ExceedanceReport />
                </ProtectedRoute>
                }
              />

              {/* RiverParameterCoparison Report */}
              <Route 
                path="/reports/river-compare"
                element={
                <ProtectedRoute>
                  <RiverParameterComparison />
                </ProtectedRoute>
                }
              />
			  
			  {/* RiverVsRiverCoparison Report */}
              <Route 
                path="/reports/river-vs-river"
                element={
                <ProtectedRoute>
                  <RiverVsRiverComparison />
                </ProtectedRoute>
                }
              />
			  
			  {/* RiverLongitudinalProfile Report */}
              <Route 
                path="/reports/river-longitudinal"
                element={
                <ProtectedRoute>
                  <RiverLongitudinalProfile />
                </ProtectedRoute>
                }
              />

            {/* Admin dashboard removed; admin uses Users dashboard */}
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
